module.exports = __webpack_public_path__ + "static/media/dtn-app-overview.6fcab966.gif";